import React from 'react'
import { useState } from 'react'
import { get, pick, isEmpty } from 'lodash'
import qs from 'query-string'
import { message } from 'antd'
import { withRouter } from 'react-router-dom'

import AddQC from './AddQC'
import useFetchObject from '../../../../../elements/Hooks/useFetchObject'
import { EnquiriesApi } from '../../../../../api/Sales/Enquiries'
import useTitle from '../../../../../elements/Hooks/useTitle'
import { QCApi } from '../../../../../api/Operations/Engineering/QC'
import DocumentsApi from '../../../../../api/Documents'
import Templates from '../../../../../api/Templates'
import Email from '../../../../../api/Email'
import useFetchList from '../../../../../elements/Hooks/useFetchList'
import useModalShow from '../../../../../elements/Hooks/useModalShow'
import Members from '../../../../../api/Members'
import useSubmit from '../../../../../elements/Hooks/useSubmit'
import { MODAL_TYPE_NEW } from '../../../../../elements/Hooks/useModalData'

const formRef = React.createRef()
const docsApi = new DocumentsApi()
const templateApi = new Templates()
const emailApi = new Email()

function AddQCCont(props) {
  const key = get(props.match, 'params.key')
  const values = qs.parse(props.location.search)
  const enquiryID = values.enquiryID
  const type = key ? 'edit' : 'new'

  const { fetch, fetching, object: qc, setObject: setQC } = useFetchObject(
    () => QCApi.read(key),
    false,
    [key],
    isEmpty(key)
  )

  useTitle(qc.code === undefined ? `Create New QC Docyment` : `${qc.code} QC`)
  const [isMemberOrganization, setIsMemberOrganization] = useState(true)
  const [ContactPersonLoading, setContactPersonLoading] = useState(false)
  const [contactPerson, setContactPerson] = useState([])
  const { list: enquirerList, fetching: fetchingEnquirer, fetch: fetchEnquirer } = useFetchList(
    EnquiriesApi.enquirerList
  )
  const {
    visible: visiblePhonebook,
    onShow: onShowPhoneBook,
    onCancel: onCancelPhoneBook,
  } = useModalShow(undefined, fetchEnquirer)

  const onChangeEnquirer = async (id) => {
    console.log('onChangeEnquirer')
    if (id) {
      setContactPersonLoading(true)
      const key = id.replace('members/', '')
      const membersApi = new Members()
      const memberResponse = await membersApi.get(key)
      let memberData = await memberResponse.json()
      setIsMemberOrganization(memberData.kind !== 'individual')
      const response = await membersApi.representatives.list(key)
      let data = await response.json()
      setContactPerson(data)
      setContactPersonLoading(false)
      return id
    }
  }

  const [updating, updateFunc] = useSubmit(QCApi.update)

  function checkForm() {
    return new Promise((res, rej) => {
      formRef.current.validateFieldsAndScroll((err, values) => {
        if (!err) {
          res(values)
        } else rej(err)
      })
    })
  }

  const [submitting, submitFunc] = useSubmit(QCApi.create)

  async function submit() {
    const values = await checkForm()
    const submitted = await submitFunc(values)
    if (submitted)
      props.history.push({
        pathname: `/operations/engineering/qc/${submitted._key}/update`,
      })
  }

  async function update() {
    const values = await checkForm()
    const qcDB = await updateFunc({
      ...pick(qc, ['_key', '_id', '_rev']),
      ...values,
    })
    if (qcDB) setQC(qcDB)
  }

  const [removing, removeFunc] = useSubmit(QCApi.remove)

  async function remove() {
    const removed = await removeFunc({
      ...pick(qc, ['_key', '_rev', '_id']),
    })
    if (removed)
      props.history.replace({
        pathname: `/operations/engineering/qc/`,
      })
  }

  const { list: actions, fetching: fetchingActions, fetch: fetchActions } = useFetchList(
    () => docsApi.actions('qc', qc.status),
    [qc.status, isEmpty(qc.status)]
  )
  const isNew = type === MODAL_TYPE_NEW
  const isUpdatable = actions.find((a) => a.key === 'update') || isNew
  const [submittingOperation, submitOperation] = useSubmit(QCApi.operation)

  async function handleActions(operation) {
    let hide = message.loading('', 0)
    const QCDB = await submitOperation({
      status: operation,
      ...pick(qc, ['_key', '_rev', '_id']),
    })
    if (QCDB) {
      setQC(QCDB)
    }
    hide()
  }

  const [submittingTemplate, submitTemplate] = useSubmit(templateApi.read, true)
  const [submittingQCTemplate, submitQCTemplate] = useSubmit(emailApi.qcTemplate, true)
  const [submittingQCFiles, submitQCFiles] = useSubmit(QCApi.files, true)

  const [emailTemplate, setEmailTemplate] = useState('')
  const [emailDetails, setEmailDetails] = useState('')
  const [emailFiles, setEmailFiles] = useState([])
  const [emailLines, setEmailLines] = useState([])

  const { visible: visibleEmail, onShow: onShowEmail, onCancel: onCancelEmail } = useModalShow(
    async () => {
      let hide = message.loading('Fetching Email Template ...', 0)

      const company = get(qc, 'company._id', '').replace('members/', '')
      const qcTemplate = await submitTemplate(company, 'qc')
      const emailDetails = get(qcTemplate, 'email') || {}
      const data = await submitQCTemplate({
        receiver: get(qc, 'vendorRep.fn'),
        ...emailDetails,
      })

      const filesList = await submitQCFiles([qc._id])
      setEmailFiles(filesList)
      const filesMapped = filesList.map((f) => f.uuid)
      setEmailTemplate(data.html)
      setEmailDetails({
        to: get(qc, 'vendorRep.email.label'),
        bcc: get(emailDetails, 'bcc'),
        from: get(emailDetails, 'from'),
        subject: get(emailDetails, 'subject'),
        attachments: filesMapped,
      })
      setEmailLines([qc])
      hide()
    }
  )
  const isConfirmed = ['Confirmed'].includes(qc.status)
  const isIssued = get(qc, 'issuance.issued') === true

  React.useEffect(() => {
    if (get(qc, 'vendor._id')) onChangeEnquirer(qc.vendor._id)
  }, [qc._key])
  const [modalID, setModalID] = React.useState(1)
  React.useEffect(() => {
    setModalID((old) => old + 1)
  }, [enquirerList.length])
  return (
    <AddQC
      {...{
        type,
        enquiryID,
        fetching,
        submitting,
        updating,
        fetch,
        qc,
        submit,
        removing,
        remove,
        update,
        formRef,
        visiblePhonebook,
        onShowPhoneBook,
        onCancelPhoneBook,
        onChangeEnquirer,
        contactPerson,
        setContactPerson,
        enquirerList,
        fetchingEnquirer,
        fetchEnquirer,
        ContactPersonLoading,
        setContactPersonLoading,
        isMemberOrganization,
        //qc cont
        isNew,
        isUpdatable,
        actions,
        fetchingActions,
        fetchActions,
        handleActions,
        onShowEmail,
        visibleEmail,
        onCancelEmail,
        emailTemplate,
        emailDetails,
        emailFiles,
        emailLines,
        isConfirmed,
        isIssued,
        modalID,
      }}
    />
  )
}

export default withRouter(AddQCCont)
